<template>
  <q-icon
    v-bind="{
      ...$attrs,
      ...props,
    }"
    class="bg-transparent"
  >
    <slot
      v-if="$slots.default"
      v-bind="$slots.default"
      name="default"
    />
  </q-icon>
</template>
<script setup lang="ts">
import { QIconProps } from 'quasar'

type FlagIcon = QIconProps

const props = defineProps<FlagIcon>()

</script>

<style scoped>
[class*=" spf-flag-"]::before {
  box-shadow: #3b476359 0px 1px 3px, #3b476359 0px 1px 2px;
}
.q-icon {
  width: auto !important;
}
</style>
